// Others
import { IBaseOption } from '~/utils/interface/common';
import { IPdfInventory } from '~/apis/financial';

export const mockDataServiceUnit: IBaseOption[] = [
  {
    label: 'Sq. Ft.',
    value: 'SQ_FT',
  },
  {
    label: 'Each',
    value: 'EACH',
  },
];

export const mockPdfMaterial: IPdfInventory = {
  services: [
    {
      id: 'ser-001',
      serviceName: 'New Service',
      quantity: 1,
      price: 10000000,
      amount: 10000000,
    },
    {
      id: 'ser-002',
      serviceName: 'Test Service',
      quantity: 1,
      price: 7000000,
      amount: 7000000,
    },
  ],
  serviceSubtotal: 10000000,
};

export const mockPdfService: IPdfInventory = {
  materials: [
    {
      id: 'mat-001',
      materialName: 'New Material',
      quantity: 100,
      price: 95000,
      amount: 9500000,
    },
    {
      id: 'mat-002',
      materialName: 'Demo Crew',
      quantity: 50,
      price: 250000,
      amount: 12500000,
    },
  ],
  materialSubtotal: 10000000,
};
